import { render, staticRenderFns } from "./Kayttajat.vue?vue&type=template&id=40f79f62&scoped=true"
import script from "./Kayttajat.vue?vue&type=script&lang=js"
export * from "./Kayttajat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f79f62",
  null
  
)

export default component.exports